import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import LectorPedidoCliente from "./LectorPedidoCliente";
import ExplosionArticulo, { renglonParaGuardar } from "./ExplosionArticulo";
import OrdenMaquilaArticulo, { finalesDeOrden } from "./OrdenMaquilaArticulo";
import AgregarColorTalla from "./AgregarColorTalla";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const renglonVacio = () => ({
  id: uuidv4(),
  articulos: "",
  articulosNombre: "",
  codigoCliente: "NA",
  precio: 0,
  precioEtiqueta: 0,
  colores: "",
  arrayColoresArticulo: [],
  tallas: "",
  arrayTallasArticulo: [],
  cantidad: 0,
  descuento: 0,
  total: 0,
  tc: [],
  totalArt: 0,
  // Explosion capturada antes de guardar; se guarda junto con el pedido.
  explosion: [],
  // Orden de maquila opcional (ver OrdenMaquilaArticulo); se crea al guardar.
  orden: null,
});

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_CORTES_DESDE_PEDIDO = process.env.REACT_APP_URL_CORTES_DESDE_PEDIDO;

  let hoy = new Date()
  // let inicio = new Date()
  // inicio.setDate(inicio.getDate()-60);

  let endDate   = moment(hoy).format("YYYY-MM-DD");
  // let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [pedidoCliente, setPedidoCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [comprador, setComprador] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState("");
  const [descuento, setDescuento] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState("");
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  const [pendFechaConf, setPendFechaConf] = useState("");

  const [telas, setTelas] = useState([]);
  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);
  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  // Un renglon por articulo: un pedido puede llevar varios modelos, cada uno
  // con su precio, precio de etiqueta, modelo oficial y su cuadricula color x talla.
  const [inputFields, setInputFields] = useState([renglonVacio()]);

  const total_piezas = inputFields.reduce((s, r) => s + (parseFloat(r.totalArt) || 0), 0);
  const total_general = inputFields.reduce(
    (s, r) => s + (parseFloat(r.totalArt) || 0) * (parseFloat(r.precio) || 0),
    0
  );
  const renglonesConArticulo = inputFields.filter((r) => r.articulos);

  // Color o talla que se agrega a un articulo del pedido: { id del renglon, tipo }.
  const [agregarEn, setAgregarEn] = useState(null);
  // Archivo (PDF/Excel) de la orden del cliente leido con el lector: se guarda con el pedido.
  const [archivoCliente, setArchivoCliente] = useState(null);
  const renglonAgregar = agregarEn ? inputFields.find((r) => r.id === agregarEn.id) : null;

  // Renglon cuya orden de maquila se esta capturando.
  const [ordenDe, setOrdenDe] = useState(null);
  const renglonOrden = inputFields.find((r) => r.id === ordenDe);
  const articuloOrden = renglonOrden ? articulos.find((a) => a._id === renglonOrden.articulos) : null;

  // Renglon cuya explosion se esta capturando.
  const [explosionDe, setExplosionDe] = useState(null);
  const renglonExplosion = inputFields.find((r) => r.id === explosionDe);
  const articuloExplosion = renglonExplosion ? articulos.find((a) => a._id === renglonExplosion.articulos) : null;
  const piezasPorColorDe = (r) => {
    const mapa = {};
    (r ? r.tc : []).forEach((c) => {
      mapa[c.colores] = (mapa[c.colores] || 0) + (parseFloat(c.cantidad) || 0);
    });
    return mapa;
  };

  const [validaBoton, setValidaBoton] = useState(true);

  useMemo(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COMPRADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCompradores = res.data;
        setCompradores(allCompradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresa = response.data;
        setEmpresas(allEmpresa);
        //
      })
      .catch((err) => {
        console.log(err);
      });
      axios
    .get(URL_TELAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allTelas = res.data;
      setTelas(allTelas);
    })
  }, []);

  // Los select arrancan en "Selecciona" con valor "0" o "", que el navegador
  // da por llenos; por eso se revisa aqui que de verdad se haya elegido algo.
  const elegido = (v) => v !== undefined && v !== null && v !== "" && v !== "0";
  const faltantes = [
    ["Fecha Venta", elegido(fecha)],
    ["Empresa", elegido(selectedEmpresa)],
    ["Cliente", !!(value && value._id)],
    ["Vendedor", elegido(selectedColaborador)],
    // Fecha de cancelacion, de confirmacion y "Pendiente fecha conf" son opcionales.
    ["Comprador", elegido(selectedComprador)],
    ["Pedido Cliente", elegido(String(pedidoCliente || "").trim())],
    ["Artículo", renglonesConArticulo.length > 0],
    ["Piezas de cada artículo", renglonesConArticulo.every((r) => r.totalArt > 0)],
    ["Precio de cada artículo", renglonesConArticulo.every((r) => parseFloat(r.precio) > 0)],
    ["Artículos sin repetir", new Set(renglonesConArticulo.map((r) => r.articulos)).size === renglonesConArticulo.length],
  ]
    .filter(([, ok]) => !ok)
    .map(([campo]) => campo);

  const savePedido = async (event) => {
    event.preventDefault();
    if (faltantes.length) {
      Swal.fire("Faltan datos", `Completa: ${faltantes.join(", ")}`, "warning");
      return;
    }
    setValidaBoton(false);
    toggleProgreso();

    // Las fechas de seguimiento salen 60 dias antes de la cancelacion; sin
    // cancelacion (es opcional) se toma la fecha del pedido.
    const fechaStatus = elegido(fecha_cancelacion)
      ? moment(fecha_cancelacion).subtract(60, "days").format("YYYY-MM-DD")
      : fecha;
    const headers = {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    };
    const renglones = renglonesConArticulo;

    try {
      const data = await axios.post(
        URL_PEDIDOS,
        {
          fecha,
          fechaEstado: fecha,
          fechaCreacion: endDate,
          resurtido: "Si",
          empresas: selectedEmpresa,
          clientes: value._id,
          colaboradores: selectedColaborador,
          // Opcionales: vacias se guardan como "NA", igual que los pedidos viejos.
          fecha_cancelacion: elegido(fecha_cancelacion) ? fecha_cancelacion : "NA",
          fecha_confirmacion: elegido(fecha_confirmacion) ? fecha_confirmacion : "NA",
          total_general,
          total_piezas,
          compradores: selectedComprador,
          observaciones,
          articulos: renglones.map((r) => r.articulos),
          pedidoCliente,
          surtido: 0,
          pendiente_surtir: total_piezas,
          confirmacionPedido: "No",
          status: "Abierto",
          fechaEstCodigos: fechaStatus,
          fechaEstFicha: fechaStatus,
          fechaEstAuditoria: fechaStatus,
          fechaEstMuestraFit: fechaStatus,
          fechaEstMuestraConfirmacion: fechaStatus,
          fechaEstEtiquetas: fechaStatus,
          fechaRealCodigos: fechaStatus,
          fechaRealFicha: fechaStatus,
          fechaRealAuditoria: fechaStatus,
          fechaRealMuestraFit: fechaStatus,
          fechaRealMuestraConfirmacion: fechaStatus,
          fechaRealEtiquetas: fechaStatus,

          autorizacionFitFecha: fechaStatus,
          autorizacionCostosFecha: fechaStatus,
          autorizacionDisenoFecha: fechaStatus,
          autorizacionCalidadFecha: fechaStatus,
          autorizacionPloterFecha: fechaStatus,
          autorizacionPloterDisenoFecha: fechaStatus,
          autorizacionSurtirFecha: fechaStatus,

          autorizacionFitColaborador: "613a9434225bce3df050c220",
          autorizacionCostosColaborador: "613a9434225bce3df050c220",
          autorizacionDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionCalidadColaborador: "613a9434225bce3df050c220",
          autorizacionPloterColaborador: "613a9434225bce3df050c220",
          autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionSurtirColaborador: "613a9434225bce3df050c220",
          descuento,
          pendFechaConf: elegido(pendFechaConf) ? pendFechaConf : "NA",
        },
        headers
      );
      const pedido = data.data;

      // Cada celda color x talla de cada articulo es un renglon del pedido.
      const celdas = [];
      renglones.forEach((r) => {
        r.tc.forEach((b) => {
          const cantidad = parseFloat(b.cantidad) || 0;
          if (cantidad <= 0) return;
          celdas.push({
            pedidos: pedido._id,
            articulos: r.articulos,
            colores: b.colores,
            tallas: b.tallas,
            cantidad,
            pendienteCortar: cantidad,
            cortado: 0,
            surtido: 0,
            pendiente_surtir: cantidad,
            cantidad_procesos: cantidad,
            precio: r.precio,
            descuento,
            total: (cantidad * parseFloat(r.precio) - (cantidad * parseFloat(r.precio)) / 100).toFixed(2),
            codigoBarras: 0,
            precioEtiqueta: r.precioEtiqueta,
            resurtido: "Si",
            codigoCliente: String(r.codigoCliente || "NA"),
          });
        });
      });
      const creadas = await Promise.all(celdas.map((c) => axios.post(URL_ARTICULOS_PEDIDO, c, headers)));
      // Renglon del pedido de cada articulo/color/talla, para las ordenes de maquila.
      const renglonDe = new Map();
      creadas.forEach((res, i) => {
        const c = celdas[i];
        renglonDe.set(`${c.articulos}|${c.colores}|${c.tallas}`, res.data._id);
      });

      // Explosion capturada por articulo en esta pantalla.
      await Promise.all(
        renglones
          .filter((r) => r.explosion && r.explosion.length)
          .map((r) =>
            axios.post(
              `${URL_EXPLOSION_GLOBAL}/articulo`,
              {
                pedidos: pedido._id,
                articulos: r.articulos,
                // Con rubro y, si no existe la habilitacion, marca/color/proveedor para darla de alta.
                renglones: r.explosion.map((e) => ({ ...renglonParaGuardar(e), _id: undefined })),
              },
              headers
            )
          )
      );

      const telasPedido = inputFieldsTela.filter((a) => a.idTela != "" && a.idColor != "" && a.cantidad > 0);
      await Promise.all(
        telasPedido.map((a) =>
          axios.post(
            URL_EXPLOSION_GLOBAL,
            {
              articulos: renglones[0].articulos,
              pedidos: pedido._id,
              telas: a.idTela,
              colores: a.idColor,
              cantidad: a.cantidad,
              tipo: "Tela",
              observaciones: a.observaciones,
            },
            headers
          )
        )
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Pedido",
          detalle: `${value._id} ${total_general}`,
          user: user.id,
        },
        headers
      );
      // La orden de compra que se leyo con el lector se guarda con el pedido
      // (se ve desde ListadoPedidos). Si falla, el pedido ya quedo: solo se avisa.
      if (archivoCliente) {
        try {
          const formData = new FormData();
          formData.append("file", archivoCliente);
          await axios.post(`${URL_PEDIDOS}/${pedido._id}/archivo`, formData, headers);
        } catch (e) {
          await Swal.fire(
            "No se guardó el archivo del cliente",
            `El pedido sí se creó. ${(e.response && e.response.data && e.response.data.message) || ""}`,
            "warning"
          );
        }
      }

      // Ordenes de maquila capturadas aqui (opcionales), una por articulo.
      const ordenesCreadas = [];
      const ordenesFallidas = [];
      for (const r of renglones.filter((x) => x.orden)) {
        const finales = finalesDeOrden(r.orden, r.tc);
        const renglonesOrden = r.tc
          .filter((c) => (parseFloat(c.cantidad) || 0) > 0)
          .map((c) => ({
            articulosPedido: renglonDe.get(`${r.articulos}|${c.colores}|${c.tallas}`),
            cantidadPedido: parseFloat(c.cantidad),
            cantidadFinal: finales[`${c.colores}|${c.tallas}`],
            sku: ((r.orden.renglones || {})[`${c.colores}|${c.tallas}`] || {}).sku || "",
          }))
          .filter((x) => x.articulosPedido);
        try {
          const { data: orden } = await axios.post(
            URL_CORTES_DESDE_PEDIDO,
            {
              fecha: endDate,
              pedidos: pedido._id,
              articulos: r.articulos,
              proveedores: r.orden.proveedores,
              fechaCompromiso: r.orden.fechaCompromiso,
              precioMaquila: parseFloat(r.orden.precioMaquila) || 0,
              consumoRealPrenda: parseFloat(r.orden.consumoRealPrenda) || 0,
              observaciones: r.orden.observaciones || "NA",
              ...(r.orden.datos || {}),
              renglones: renglonesOrden,
            },
            headers
          );
          // Una orden por color (tono) del articulo.
          (orden.ordenes || [orden]).forEach((o) =>
            ordenesCreadas.push(
              `${o.cortes.folioCAV} (${r.codigoCliente}${o.colorNombre ? ` ${o.colorNombre}` : ""}: ${o.totalProducir} pzas)`
            )
          );
        } catch (e) {
          ordenesFallidas.push(`${r.codigoCliente}: ${(e.response && e.response.data && e.response.data.message) || e.message}`);
        }
      }

      setModalProgreso(false);
      if (ordenesCreadas.length || ordenesFallidas.length) {
        await Swal.fire({
          icon: ordenesFallidas.length ? "warning" : "success",
          title: `Pedido ${pedido.idPedido} creado`,
          html:
            (ordenesCreadas.length ? `Órdenes de maquila: <b>${ordenesCreadas.join(", ")}</b><br/>` : "") +
            (ordenesFallidas.length
              ? `No se pudo crear la orden de: ${ordenesFallidas.join("; ")}.<br/>Hazla desde Órdenes de Maquila.`
              : ""),
        });
        window.location.reload();
        return;
      }
      // La orden de maquila es opcional: se puede generar desde aqui mismo.
      const r = await Swal.fire({
        icon: "success",
        title: `Pedido ${pedido.idPedido} creado`,
        text: "¿Quieres generar ahora la orden de maquila?",
        showCancelButton: true,
        confirmButtonText: "Sí, generar orden",
        cancelButtonText: "No, terminar",
      });
      if (r.value) {
        window.location.href = `/CortesCreate?pedido=${pedido._id}`;
      } else {
        window.location.reload();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? JSON.stringify(error.response.data) : error.message}`,
      });
      console.log(error);
      setModalProgreso(false);
      setValidaBoton(true);
    }
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, renglonVacio()]);
  };

  const handleRemoveFields = (id) => {
    const values = inputFields.filter((r) => r.id !== id);
    setInputFields(values.length ? values : [renglonVacio()]);
  };

  /** Modelo oficial, precio o precio de etiqueta de un renglon. */
  const handleChangeRenglon = (id, campo, valor) => {
    setInputFields(
      inputFields.map((r) => {
        if (r.id !== id) return r;
        const nuevo = { ...r, [campo]: valor };
        nuevo.total = (parseFloat(nuevo.totalArt) || 0) * (parseFloat(nuevo.precio) || 0);
        return nuevo;
      })
    );
  };

  const handleChangeInputCantidad = (id, colores, tallas, event) => {
    const valor = event.target.value;
    setInputFields(
      inputFields.map((r) => {
        if (r.id !== id) return r;
        const tc = r.tc.map((a) => (a.colores == colores && a.tallas == tallas ? { ...a, cantidad: valor } : a));
        const totalArt = tc.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0);
        return { ...r, tc, totalArt, total: totalArt * (parseFloat(r.precio) || 0) };
      })
    );
  };

  function nombreArticulo(a) {
    return a.codigo + " " + a.codigoCliente + " " + (a.clientes?.[0]?.nombre_comercial ?? "");
  }

  /** Renglon con la cuadricula color x talla del articulo (mas los extras que traiga el pedido). */
  function renglonDeArticulo(articulo, extra = {}) {
    const coloresArticulo = [...(articulo.colores || [])];
    const tallasArticulo = [...(articulo.tallas || [])];
    (extra.renglones || []).forEach((r) => {
      if (!coloresArticulo.some((c) => c._id === r.colores)) coloresArticulo.push({ _id: r.colores, name: r.colorNombre });
      if (!tallasArticulo.some((t) => t._id === r.tallas)) tallasArticulo.push({ _id: r.tallas, name: r.tallaNombre });
    });
    // Las tallas agregadas quedan al final; si todas son numeros se ordenan (5, 7, 9...).
    if (tallasArticulo.every((t) => /^\d+(\.\d+)?$/.test(String(t.name).trim()))) {
      tallasArticulo.sort((a, b) => parseFloat(a.name) - parseFloat(b.name));
    }
    const tc = [];
    coloresArticulo.forEach((c) => {
      tallasArticulo.forEach((t) => {
        const cantidad = (extra.renglones || [])
          .filter((r) => r.colores === c._id && r.tallas === t._id)
          .reduce((s, r) => s + r.cantidad, 0);
        tc.push({ colores: c._id, colorNombre: c.name, tallas: t._id, tallaNombre: t.name, cantidad });
      });
    });
    const precio = extra.precio !== undefined && extra.precio !== null ? extra.precio : articulo.venta || 0;
    const totalArt = tc.reduce((s, x) => s + (parseFloat(x.cantidad) || 0), 0);
    return {
      ...renglonVacio(),
      articulos: articulo._id,
      articulosNombre: nombreArticulo(articulo),
      codigoCliente: extra.codigoCliente || articulo.codigoCliente || "NA",
      precio,
      precioEtiqueta: extra.precioEtiqueta !== undefined && extra.precioEtiqueta !== null ? extra.precioEtiqueta : 0,
      arrayColoresArticulo: coloresArticulo,
      arrayTallasArticulo: tallasArticulo,
      tc,
      totalArt,
      total: totalArt * (parseFloat(precio) || 0),
    };
  }

  function BuscaArticulo(id, selectedArticulo) {
    if (!selectedArticulo) return;
    const articulo = articulos.find((a) => a._id == selectedArticulo._id);
    if (!articulo) return;
    if (inputFields.some((r) => r.id !== id && r.articulos === articulo._id)) {
      Swal.fire("Ya está en el pedido", "Ese artículo ya tiene su renglón; captura ahí sus piezas", "warning");
      return;
    }
    setInputFields(
      inputFields.map((r) => (r.id === id ? { ...renglonDeArticulo(articulo), id: r.id } : r))
    );
  }

  function explosiones() {
    
    setInputFieldsTela([
      {
        id: uuidv4(),
        idTela: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    toggleExplosiones();
  }

  const handleRemoveFieldsTelas = (id) => {
    const values = [...inputFieldsTela];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTela(values);
  };


const handleAddFieldsTelas = () => {
  setInputFieldsTela([
    ...inputFieldsTela,
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);
};
const handleChangeInputTela = (id, event) => {
  const newInputFieldsTela = inputFieldsTela.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsTela(newInputFieldsTela);
};

  /** Rearma la cuadricula color x talla conservando lo ya capturado. */
  function cuadricula(r, coloresR, tallasR) {
    const tc = [];
    coloresR.forEach((c) => {
      tallasR.forEach((t) => {
        const previa = r.tc.find((x) => x.colores === c._id && x.tallas === t._id);
        tc.push({ colores: c._id, colorNombre: c.name, tallas: t._id, tallaNombre: t.name, cantidad: previa ? previa.cantidad : 0 });
      });
    });
    return tc;
  }

  /**
   * Agrega un color o una talla (ya existente en el catalogo) al renglon del
   * articulo; con `alArticulo` tambien queda en el articulo para otros pedidos.
   */
  const agregarColorTalla = async (registro, alArticulo, esNuevo) => {
    const { id, tipo } = agregarEn;
    const campo = tipo === "Color" ? "colores" : "tallas";
    const renglon = inputFields.find((r) => r.id === id);
    if (esNuevo) {
      if (tipo === "Color") setColores((l) => [...l, registro]);
      else setTallas((l) => [...l, registro]);
    }
    if (alArticulo) {
      const articulo = articulos.find((a) => a._id === renglon.articulos) || {};
      const ids = (articulo[campo] || []).map((x) => (x && x._id ? x._id : x)).filter(Boolean);
      if (!ids.includes(registro._id)) {
        await axios.patch(
          `${URL_ARTICULOS}/${renglon.articulos}`,
          { [campo]: [...ids, registro._id] },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        setArticulos((lista) =>
          lista.map((a) => (a._id === renglon.articulos ? { ...a, [campo]: [...(a[campo] || []), registro] } : a))
        );
      }
    }
    setInputFields((filas) =>
      filas.map((r) => {
        if (r.id !== id) return r;
        const coloresR = tipo === "Color" ? [...r.arrayColoresArticulo, registro] : r.arrayColoresArticulo;
        let tallasR = tipo === "Talla" ? [...r.arrayTallasArticulo, registro] : r.arrayTallasArticulo;
        if (tallasR.every((t) => /^\d+(\.\d+)?$/.test(String(t.name).trim()))) {
          tallasR = [...tallasR].sort((a, b) => parseFloat(a.name) - parseFloat(b.name));
        }
        return { ...r, arrayColoresArticulo: coloresR, arrayTallasArticulo: tallasR, tc: cuadricula(r, coloresR, tallasR) };
      })
    );
  };

  /** Alta de compradora desde el pedido; queda ligada al cliente elegido. */
  const altaCompradora = async () => {
    if (!value || !value._id) {
      Swal.fire("Primero elige el cliente", "La compradora se da de alta para ese cliente", "info");
      return;
    }
    const r = await Swal.fire({
      title: "Nueva compradora",
      text: `Cliente: ${value.nombre_comercial || ""}`,
      input: "text",
      inputPlaceholder: "Nombre de la compradora",
      showCancelButton: true,
      confirmButtonText: "Dar de alta",
      cancelButtonText: "Cancelar",
      inputValidator: (v) => (!String(v || "").trim() ? "Escribe el nombre" : undefined),
    });
    if (!r.value) return;
    const nombre = String(r.value).trim().toUpperCase();
    const existe = compradores.find((c) => String(c.name || "").trim().toUpperCase() === nombre);
    if (existe) {
      setSelectedComprador(existe._id);
      Swal.fire("Ya existía", `${existe.name} quedó seleccionada`, "info");
      return;
    }
    try {
      const { data } = await axios.post(
        URL_COMPRADORES,
        { name: nombre, clientes: value._id },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setCompradores((l) => [...l, data]);
      setSelectedComprador(data._id);
    } catch (error) {
      Swal.fire(
        "No se pudo dar de alta",
        (error.response && error.response.data && error.response.data.message) || "Intenta de nuevo",
        "error"
      );
    }
  };

  /** El lector dio de alta un cliente, articulo, color o talla: se recargan las listas. */
  const recargarCatalogos = async () => {
    const opciones = {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    };
    const [arts, cols, tals, clis, comps] = await Promise.all([
      axios.get(URL_ARTICULOS, opciones),
      axios.get(URL_COLORES, opciones),
      axios.get(URL_TALLAS, opciones),
      axios.get(URL_CLIENTES, opciones),
      axios.get(URL_COMPRADORES, opciones),
    ]);
    setClientes(clis.data);
    setCompradores(comps.data);
    setArticulos(arts.data);
    setColores(cols.data);
    setTallas(tals.data);
  };

  /**
   * Prellena la pantalla con un modelo leido de la orden de compra del cliente
   * (ver LectorPedidoCliente). Los colores o tallas del pedido que el articulo
   * no tiene dados de alta se agregan a la cuadricula solo para este pedido.
   */
  const aplicarLectura = (datos) => {
    const faltan = datos.modelos.filter((m) => !articulos.find((a) => a._id === m.articulo));
    if (faltan.length) {
      Swal.fire("Artículo no encontrado", "Recarga la pantalla e intenta de nuevo", "error");
      return;
    }
    setArchivoCliente(datos.archivo || null);
    const clienteOpcion = options.find((o) => o._id === datos.cliente);
    if (clienteOpcion) setValue(clienteOpcion);
    setPedidoCliente(datos.pedidoCliente);
    setFecha(datos.fechaPedido || moment().format("YYYY-MM-DD"));
    // Vendedor y comprador de la orden, si existen en el sistema.
    if (datos.vendedor) setSelectedColaborador(datos.vendedor);
    if (datos.comprador) setSelectedComprador(datos.comprador);
    if (datos.fechaCancelacion) {
      setFechaCancelacion(datos.fechaCancelacion);
      setFechaConfirmacion(
        datos.fechaConfirmacion ||
          moment(datos.fechaCancelacion).subtract(41, "days").format("YYYY-MM-DD")
      );
    }

    const agregados = [];
    const nuevos = datos.modelos.map((m) => {
      const articulo = articulos.find((a) => a._id === m.articulo);
      m.renglones.forEach((r) => {
        if (!(articulo.colores || []).some((c) => c._id === r.colores)) agregados.push(`${articulo.codigo}: color ${r.colorNombre}`);
        if (!(articulo.tallas || []).some((t) => t._id === r.tallas)) agregados.push(`${articulo.codigo}: talla ${r.tallaNombre}`);
      });
      return renglonDeArticulo(articulo, m);
    });
    setInputFields(nuevos);

    const piezas = nuevos.reduce((s, r) => s + r.totalArt, 0);
    const pendientesDeElegir = [
      "Empresa",
      datos.vendedor ? null : "Vendedor",
      datos.comprador ? null : "Comprador",
    ].filter(Boolean);
    Swal.fire({
      icon: "success",
      title: `${nuevos.length} ${nuevos.length === 1 ? "artículo" : "artículos"}, ${piezas} piezas`,
      html:
        (agregados.length
          ? `No estaban dados de alta en el artículo: ${[...new Set(agregados)].join(", ")}. Se agregaron solo a este pedido.<br/><br/>`
          : "") + `Revisa y completa: ${pendientesDeElegir.join(", ")}.`,
    });
  };

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = articulos.map((option) => {
    const junta =
      option.codigo +
      " " +
      option.codigoCliente +
      " " +
      (option.clientes?.[0]?.nombre_comercial ?? "");
    const firstLetter = option.codigo?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-clipboard-list" style={{ marginRight: 8, color: "#3b82f6" }} />
                Nuevo Pedido
              </h3>
              <p className="page-subtitle">Registra un pedido de venta</p>
            </div>
            <div className="page-actions">
              <LectorPedidoCliente
                clientes={clientes}
                colores={colores}
                tallas={tallas}
                articulos={articulos}
                compradores={compradores}
                colaboradores={colaboradores}
                onAplicar={aplicarLectura}
                onCatalogoCambiado={recargarCatalogos}
              />
            </div>
          </div>
          <OrdenMaquilaArticulo
            isOpen={!!ordenDe && !!articuloOrden}
            toggle={() => setOrdenDe(null)}
            articulo={articuloOrden}
            modeloCliente={renglonOrden ? renglonOrden.codigoCliente : ""}
            tc={renglonOrden ? renglonOrden.tc : []}
            valor={renglonOrden ? renglonOrden.orden : null}
            onListo={(orden) => setInputFields(inputFields.map((r) => (r.id === ordenDe ? { ...r, orden } : r)))}
          />
          <ExplosionArticulo
            isOpen={!!explosionDe && !!articuloExplosion}
            toggle={() => setExplosionDe(null)}
            pedido={null}
            articulo={articuloExplosion}
            piezasPorColor={piezasPorColorDe(renglonExplosion)}
            renglonesIniciales={renglonExplosion ? renglonExplosion.explosion : []}
            otrasExplosiones={inputFields
              .filter((r) => r.articulos && r.id !== explosionDe)
              .map((r) => ({ articulo: articulos.find((a) => a._id === r.articulos), renglones: r.explosion }))}
            onListo={(lista) =>
              setInputFields(inputFields.map((r) => (r.id === explosionDe ? { ...r, explosion: lista } : r)))
            }
          />
          <Form onSubmit={savePedido}>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-info-circle" />
              <span className="form-section-title">Datos Generales</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={2}>
                <Label>Fecha Venta</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cliente</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedCliente) => {
                    setValue(selectedCliente);
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>{option.nombre_comercial}</React.Fragment>
                  )}
                />
              </Col>

              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Fecha Cancelacion (opcional)</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cancelacion"
                  value={fecha_cancelacion}
                  onChange={(e) => {
                    const v = e.target.value;
                    setFechaCancelacion(v);
                    // La confirmacion se propone 41 dias antes; si se borra la cancelacion, no se toca.
                    if (v) setFechaConfirmacion(moment(v).subtract(41, "days").format("YYYY-MM-DD"));
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Confirmacion (opcional)</Label>
                <Input
                  type="date"
                  placeholder="Fecha Confirmacion"
                  value={fecha_confirmacion}
                  onChange={(e) => {
                    setFechaConfirmacion(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Pendiente Fecha Conf (opcional)</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={pendFechaConf}
                      onChange={(e) => {
                        setPendFechaConf(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Comprador</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedComprador}
                  required
                  onChange={(e) => {
                    setSelectedComprador(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {compradores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
                <Button size="sm" color="link" className="p-0 mt-1" onClick={altaCompradora}>
                  + Dar de alta compradora
                </Button>
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Pedido Cliente
                </Label>
                <Input
                  type="text"
                  placeholder="Pedido Cliente"
                  value={pedidoCliente}
                  required
                  onChange={(e) => {
                    setPedidoCliente(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones Diseño
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                    Agregar Consumo
                  </Label>
                  <br />
              <Button title="Explosión de materiales"
                            color="success"
                            id="explosion"
                            onClick={(e) =>
                              explosiones()
                            }
                          >
                            <i class="fas fa-tape"></i>
                          </Button>
              </Col> */}
            </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-tshirt" />
              <span className="form-section-title">Artículos</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            <br />
            {/* Tabla Articulos */}

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Buscar</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Modelo Oficial</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio Etiqueta</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options2.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>{option.codigo} {option.codigoCliente} {option.clientes?.[0]?.nombre_comercial}</React.Fragment>
                      )}
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      name="articulo"
                      type="string"
                      placeholder="Articulo"
                      value={inputField.articulosNombre}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      type="text"
                      placeholder="CodigoCliente"
                      value={inputField.codigoCliente}
                      required
                      onChange={(e) => handleChangeRenglon(inputField.id, "codigoCliente", e.target.value)}
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="precio"
                      type="number"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(e) => handleChangeRenglon(inputField.id, "precio", e.target.value)}
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="precioEtiqueta"
                      type="number"
                      placeholder="PrecioEtiqueta"
                      value={inputField.precioEtiqueta}
                      required
                      onChange={(e) => handleChangeRenglon(inputField.id, "precioEtiqueta", e.target.value)}
                    />
                  </Col>


                  <Col md={1}>
                    <Input
                      name="totalArt"
                      type="number"
                      placeholder="Piezas"
                      value={inputField.totalArt}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="total"
                      type="number"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                  <Col md={2} className="d-flex" style={{ gap: 4 }}>
                    <Button
                      size="sm"
                      className="btn"
                      color={inputField.explosion && inputField.explosion.length ? "success" : "info"}
                      title="Explosión del artículo"
                      disabled={!inputField.articulos}
                      onClick={() => setExplosionDe(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-tape"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color={inputField.orden ? "success" : "secondary"}
                      title="Orden de maquila (opcional)"
                      disabled={!inputField.articulos}
                      onClick={() => setOrdenDe(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-cut"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      title="Quitar artículo"
                      disabled={inputFields.length === 1 && !inputField.articulos}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                  </Col>
                </Row>
                {inputField.arrayColoresArticulo.map((col) => {
                  return (
                    <>
                      <Row>
                        <Col md={9} className="tallas">
                          <Col md={1}>
                            <Label>{col.name}</Label>
                          </Col>
                          {inputField.tc.map((a) => {
                            if (a.colores == col._id) {
                              return (
                                <>
                                  <Col md={1}>
                                    <Label>{a.tallaNombre}</Label>
                                    <Input
                                      bsSize="sm"
                                      name="cantidad"
                                      type="number"
                                      value={a.cantidad}
                                      required
                                      onChange={(event) =>
                                        handleChangeInputCantidad(
                                          inputField.id,
                                          a.colores,
                                          a.tallas,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                </>
                              );
                            }
                          })}
                        </Col>
                      </Row>
                    </>
                  );
                })}
                {inputField.articulos ? (
                  <div className="mt-1" style={{ marginLeft: 15 }}>
                    <Button size="sm" color="link" className="p-0 mr-3" onClick={() => setAgregarEn({ id: inputField.id, tipo: "Color" })}>
                      + Color
                    </Button>
                    <Button size="sm" color="link" className="p-0" onClick={() => setAgregarEn({ id: inputField.id, tipo: "Talla" })}>
                      + Talla
                    </Button>
                  </div>
                ) : null}
                <br />
              </div>
            ))}
            <AgregarColorTalla
              isOpen={!!renglonAgregar}
              toggle={() => setAgregarEn(null)}
              tipo={agregarEn ? agregarEn.tipo : "Color"}
              catalogo={agregarEn && agregarEn.tipo === "Talla" ? tallas : colores}
              existentes={
                renglonAgregar
                  ? (agregarEn.tipo === "Talla" ? renglonAgregar.arrayTallasArticulo : renglonAgregar.arrayColoresArticulo).map((x) => x._id)
                  : []
              }
              articulo={renglonAgregar ? articulos.find((a) => a._id === renglonAgregar.articulos) : null}
              onAgregar={agregarColorTalla}
            />
            <Button size="sm" color="info" onClick={handleAddFields}>
              <i className="fas fa-plus" style={{ marginRight: 6 }} /> Agregar artículo
            </Button>
            <Row className="mt-3">
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}
            </div>
          </div>

            <div className="submit-bar">
            <Button
              href="/ListadoPedidos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            {faltantes.length ? (
              <span className="text-muted mr-3" style={{ fontSize: 13 }}>
                Falta: {faltantes.join(", ")}
              </span>
            ) : null}
            {validaBoton && !faltantes.length ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
            </div>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
          <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
        <ModalHeader toggle={toggleExplosiones}>
          <h4>
            Explosion Modelo
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Tela</Label>
            </Col>
            <Col md={2}>
              <Label>Color</Label>
            </Col>
            <Col md={2}>
              <Label>Metros Totales</Label>
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
            </Col>
          </Row>
    
          {inputFieldsTela.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="idTela"
                    type="select"
                    value={a.idTela}
                    required
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {telas
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} / {a.tiposTelas?.[0]?.name}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="idColor"
                    type="select"
                    value={a.idColor}
                    required
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {colores
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.name} 
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="observaciones"
                    type="text"
                    value={a.observaciones}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col>
                  <Button title="Quitar renglón"
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFieldsTela.length === 1}
                    onClick={() => handleRemoveFieldsTelas(a.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button title="Agregar renglón"
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsTelas}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <br />
        
          
        
          </ModalBody>
      </Modal>
        
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
